
import { AppStore } from "./app-store";

const store = {
  app: new AppStore(),
};

export default store;



// WEBPACK FOOTER //
// ./src/stores/index.js